import { AngularFireDatabase } from 'angularfire2/database';
import { Order } from '../model/order';
import { AngularFireFunctions } from '@angular/fire/functions';
import { delay } from 'rxjs/operators';

export class EmailHelper {

    constructor(private db: AngularFireDatabase, private firebaseFn: AngularFireFunctions) { }

    ordersList: Order[];
    sendEmailOrderList: Order[] = [];
    startProcessing: boolean = false;
    emailCounter: number = 0;

    /** Send Emails to admin for all the orders created after the input order ID */
    sendEmailsAfterOrderId(): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {
            this.db.list('/order').snapshotChanges().subscribe(
                response => {
                    this.ordersList = response.map(c => (
                        {
                            key: c.payload.key, ...(c.payload.val() as any)
                        }
                    ));
                    if (this.ordersList && this.ordersList.length > 0) {
                        this.ordersList.forEach(order => {
                            let time = order.receiptDetails.receiptUrl.substring(order.receiptDetails.receiptUrl.lastIndexOf("_") + 1, order.receiptDetails.receiptUrl.indexOf("?alt"));
                            //console.log(new Date("08/21/2020").getTime(), time, new Date("08/28/2020").getTime());
                            if (parseInt(time) >= new Date("08/21/2020").getTime() && parseInt(time) <= new Date("08/27/2020").getTime()) {
                                this.sendEmailOrderList.push(order);
                                this.emailCounter++;
                            }

                        });

                        if (this.sendEmailOrderList && this.sendEmailOrderList.length > 0) {
                            for (let index = 21; index < 33; index++) {
                                // this.sendEmail(this.sendEmailOrderList[index]);
                            }
                            /*setTimeout(() => {
                                for (let index = 11; index < 21; index++) {
                                    this.sendEmail(this.sendEmailOrderList[index]);
                                }
                            }, 3000);
                            setTimeout(() => {
                                for (let index = 21; index < 33; index++) {
                                    this.sendEmail(this.sendEmailOrderList[index]);
                                }
                            }, 6000);*/
                        }
                        resolve();
                    } else {
                        resolve();
                    }
                }, error => {
                    reject();
                }
            );
        });
        return promise;
    }

    sendEmail(orderObject) {
        /*var functions = this.firebaseFn.functions;
        //let toEmail = "n.vaidu@gmail.com;baktavatsalam@smartual.ai";
        let toEmail = "bs@lsspi.com;chyehuat@scgmbhd.com;davidcheng@scgmbhd.com;scgm.order@lsspi.com";
        const callable = functions.httpsCallable('sendMail');
        var reqBody = {
            "emails": toEmail,
            "orderkey": orderObject.key,
            "receipt": orderObject.receiptDetails.receiptUrl,
            "fileName": orderObject.receiptDetails.fileName,
            "fileType": orderObject.receiptDetails.fileType,
            "order": JSON.stringify(orderObject)
        };
        callable(reqBody).then(response => {
            console.log("Email sent to ", orderObject.key);
        }).catch(error => {
            console.log(error);
        });*/
    }
}
